import React from "react";
import { NavLink, Link, withRouter } from "react-router-dom";
// used for making the prop types of this component
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Nav, Collapse, Button } from "reactstrap";

// core components
import { submitLogout } from "../../redux/actions/authentication";
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { getLocalUserState } from '../../redux/selectors/authentication';
import { isEmpty, intersection } from 'lodash';

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      ...this.getCollapseStates(props.routes)
    };
    this.sidebar = React.createRef();
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1 || navigator.platform.indexOf("Mac") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1 || navigator.platform.indexOf("Mac") > -1) {
      ps.destroy();
    }
    // to stop the warning of calling setState of unmounted component
    var id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = routes => {
    return routes.map((prop, key) => {
			if(prop.permissions) {
				if( isEmpty(this.props.localUser) ) {
					return null;
				}

				const user_permissions = this.props.localUser.permissions.map( x => x.name );

				if( intersection( user_permissions, prop.permissions ).length === 0 ) {
					return null;
				}
			}
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <span
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
							}}
							className="nav-link"
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </span>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      return (
        <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink to={prop.layout + prop.path} activeClassName="">
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </>
            )}
          </NavLink>
        </li>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return window.location.href.indexOf(routeName) > -1 ? "active" : "";
	};

	handleLogout = async (event) => {
		try {
			this.props.dispatch( submitLogout() ).then(( result ) => {
				this.props.history.push( '/auth/' );
			});
		} catch(err) {
			console.error(err);
			toast.dismiss();
			toast.error( `${err.response.data.message} Code: ${err.response.data.code}`, {
				autoClose: false,
				hideProgressBar: true
			} );
		}
	}

  render() {
    return (
      <>
        <div className="sidebar">
          <div className="logo">
            <Link className="simple-text logo-mini mr-0" to="/companies/" >
              <div className="logo-img">
                <img src="http://placehold.it/58x57" alt="" />
              </div>
            </Link>
            <Link className="simple-text logo-normal" to="/companies" >
              <div className="logo-img">
                <img src="http://placehold.it/248x57" alt="" aria-hidden="true" />
              </div>
            </Link>
            <div className="navbar-minimize">
              <Button
                outline
                className="btn-round btn-icon"
                color="neutral"
                id="minimizeSidebar"
                onClick={() => this.props.minimizeSidebar()}
              >
                <i className="now-ui-icons text_align-center visible-on-sidebar-regular" />
                <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini" />
              </Button>
            </div>
          </div>

          <div className="sidebar-wrapper" ref={this.sidebar}>
            <div className="user">
              <div className="photo">
                <img src="http://placehold.it/50x50" alt="Avatar" />
              </div>
              <div className="info">
                <span
									className="nav-link"
                  data-toggle="collapse"
                  aria-expanded={this.state.openAvatar}
                  onClick={() =>
                    this.setState({ openAvatar: !this.state.openAvatar })
                  }
                >
                  <span>
                    {this.props.localUser.first_name} {this.props.localUser.last_name}
                    <b className="caret" />
                  </span>
                </span>
                <Collapse isOpen={this.state.openAvatar}>
                  <ul className="nav">
                    {/* <li>
                      <a href="#pablo" onClick={e => e.preventDefault}>
                        <span className="sidebar-mini-icon">MP</span>
                        <span className="sidebar-normal">My Profile</span>
                      </a>
                    </li>
                    <li>
                      <a href="#pablo" onClick={e => e.preventDefault}>
                        <span className="sidebar-mini-icon">EP</span>
                        <span className="sidebar-normal">Edit Profile</span>
                      </a>
                    </li>
                    <li>
                      <a href="#pablo" onClick={e => e.preventDefault}>
                        <span className="sidebar-mini-icon">S</span>
                        <span className="sidebar-normal">Settings</span>
                      </a>
                    </li> */}
                    <li>
                      <span className="nav-link" onClick={this.handleLogout}>
												<span className="sidebar-mini-icon">
													<i className="now-ui-icons media-1_button-power" />
												</span>
												<span className="sidebar-normal">
													Logout
												</span>
                      </span>
                    </li>
                  </ul>
                </Collapse>
              </div>
            </div>
            <Nav>{this.createLinks(this.props.routes)}</Nav>
          </div>
        </div>
      </>
    );
  }
}

Sidebar.defaultProps = {
  routes: [],
  minimizeSidebar: () => {}
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  minimizeSidebar: PropTypes.func
};

export default connect(
	state => ({ localUser: getLocalUserState(state) })
)(withRouter(Sidebar));
